import { useInfiniteQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import api from 'config/api';
import requester from 'utils/requester';
import { LIST_MAX_SIZE as ITEMS_PER_REQUEST } from 'config';
import urlHelper from 'helpers/urlhelper';
import { getIsLoggedInSelector } from 'reducers/profile/selectors';

export const KEY = 'USE_LOAD_LIST';

const apiCall = async ({ id, isLoggedIn, pageParam = {} }) => {
  const endpoint = urlHelper.getAuthorizedEndpointUrl(api.endpoints.list, isLoggedIn);
  const data = await requester({
    method: 'get',
    url: `${api.host}${endpoint}${id}`,
    params: {
      detailed: true,
      size: ITEMS_PER_REQUEST,
      page: pageParam.page ?? 0,
      getCarouselTitle: true,
    },
  });

  return data;
};

const useLoadList = (id, options) => {
  const isLoggedIn = useSelector(getIsLoggedInSelector);

  return useInfiniteQuery([KEY, id], ({ pageParam }) => apiCall({ id, isLoggedIn, pageParam }), {
    select(data) {
      const flattern = data.pages.flat();

      const title = flattern[0].title;
      const titles = flattern[0].titles;
      const content = flattern.reduce((r, c) => r.concat(c.content), []);

      return { title, titles, content };
    },
    getNextPageParam: (lastPage) => {
      if (!isEmpty(lastPage.content)) return { page: lastPage.number + 1 };
    },
    ...options,
  });
};

export default useLoadList;
